import * as React from "react";
import { Dropdown } from "../../../forms/informedv2/Dropdown";
import { Option, Scope, Text } from "informed";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";
import { HasPermission } from "../../../misc/components/Authorization";
import { nameof } from "ts-simple-nameof";
import { CommentEntry, DefaultCommentFormModel } from "./FixedCommentsTable";
import { FixedCommentSet } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useSecurityContext } from "../../../Core/SecurityContext";

interface DefaultAcceptableCommentDropdownProps {
    set: FixedCommentSet;
    onChange(setId, defaultAcceptableCommentId) : void;
    value: string;
}

export enum DefaultFixedCommentOptionTypes {
    None = "DFC_NONE"
}

export const DefaultAcceptableCommentDropdown = ({ set, onChange, value }: DefaultAcceptableCommentDropdownProps): JSX.Element => {
    const { study } = useCurrentStudyConfigurationContext();
    const { currentUserPermissions } = useSecurityContext();

    return (!!set ? <Scope scope={`${nameof<DefaultCommentFormModel>(s => s.defaultComments)}[${set.id}]`}>
        <Dropdown initialValue={value} field={nameof<CommentEntry>(s => s.DefaultComment)} onChange={(evt)=> onChange(set.id, evt.target.value)} disabled={!HasPermission(currentUserPermissions, study.id, PermissionEnum.EditFixedComment)}>
            <Option value={DefaultFixedCommentOptionTypes.None}></Option>
            {set.comments.map(c => (<Option key={c.id} value={c.id}>{c.comment}</Option>))}
        </Dropdown>
        <Text field={nameof<CommentEntry>(s => s.SetType)} hidden={true} />
    </Scope> : <>-</>);
}
